if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // 注意：基类 ModalDialog 的构造器会：
        // 1. 绑定 ModalClose 按钮的 click 事件（已在 liquid 中添加按钮）
        // 2. 绑定 pointerup 事件并调用 this.hide()（将在 connectedCallback 中拦截）
        this.initGallery();
      }

      connectedCallback() {
        // 首先执行基类的 connectedCallback（移动到 body）
        super.connectedCallback();
        // 基类在构造器中绑定了：
        //   this.addEventListener('pointerup', (event) => { if (...) this.hide(); })
        // 该监听器是唷名函数，无法直接 removeEventListener。
        // 解决方法：在捕获阶段（capture: true）拦截并阻止 pointerup 传播，
        // 这样冠泡阶段的基类监听器就无法执行了。
        this.addEventListener('pointerup', (e) => {
          // 只遇到 mouse 类型的 pointerup 才拦截（和基类监听器的触发条件一致）
          if (e.pointerType === 'mouse') {
            e.stopImmediatePropagation();
          }
        }, true); // capture: true 确保在基类监听器之前执行
      }

      initGallery() {
        console.log("【Antigravity】大图预览图层：智能切换与动态自适应指针交互逻辑已成功加载！");
        this.slider = this.querySelector('.custom-modal-slider');
        this.slides = Array.from(this.querySelectorAll('.custom-modal-slide'));
        this.thumbs = Array.from(this.querySelectorAll('.custom-modal-thumb'));

        // 绑定缩略图点击
        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goToSlide(index);
          });
        });

        // 监听滚动更新高亮
        if (this.slider) {
          this.slider.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
              this.updateActiveThumb();
            }, 100);
          });
        }

        // 极高精度的鼠标交互算法：穿透 `object-fit: contain` 的透明黑洞
        const mainWrapper = this.querySelector('.custom-modal-main');
        if (mainWrapper) {
          // 精确计算鼠标坐标是否落在 "真实渲染出来的图片可见像素" 上
          const isEventOnImageContent = (e) => {
            let img = null;
            if (e.target.tagName === 'IMG') {
              img = e.target;
            } else {
              const slide = e.target.closest('.custom-modal-slide');
              if (slide) img = slide.querySelector('img');
            }
            // 如果连 img 元素都没有找到，说明肯定在空白区
            if (!img) return false;
            
            // 如果图片尚未加载完成，无法获取原始比例，安全起见认为是图片上
            if (!img.naturalWidth || !img.naturalHeight) return true;
            
            const boxRect = img.getBoundingClientRect();
            // 计算由于 object-fit: contain 产生的实际缩放比例
            const scale = Math.min(boxRect.width / img.naturalWidth, boxRect.height / img.naturalHeight);
            
            const renderedWidth = img.naturalWidth * scale;
            const renderedHeight = img.naturalHeight * scale;
            
            // 由于 default object-position 为 50% 50%，图片在盒子正中央
            const renderedLeft = boxRect.left + (boxRect.width - renderedWidth) / 2;
            const renderedTop = boxRect.top + (boxRect.height - renderedHeight) / 2;
            
            return (e.clientX >= renderedLeft && e.clientX <= renderedLeft + renderedWidth &&
                    e.clientY >= renderedTop && e.clientY <= renderedTop + renderedHeight);
          };

          // 1. 拦截所有点击（全局一视同仁放大/缩小，除了导航箭头之外）
          mainWrapper.addEventListener('click', (e) => {
            // 点击原生的左右小箭头，不处理，让它们自己的事件去跑
            if (e.target.closest('.custom-modal-nav')) return;
            
            // 实时算出当前正中间可视大图的 index
            let currentIndex = 0;
            let minDiff = Infinity;
            const scrollCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
            this.slides.forEach((slide, index) => {
              const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
              const diff = Math.abs(slideCenter - scrollCenter);
              if (diff < minDiff) {
                minDiff = diff;
                currentIndex = index;
              }
            });
            
            // 拿到当前正在显示的大图 img 并进行放大/缩小切换
            const activeSlide = this.slides[currentIndex];
            const img = activeSlide?.querySelector('img');
            if (img) {
              // 在点击的瞬间，立刻计算并注入一次 transform-origin，防止静止状态点击产生的跳动
              const slideRect = activeSlide.getBoundingClientRect();
              const x = e.clientX - slideRect.left;
              const y = e.clientY - slideRect.top;
              const xPercent = Math.max(0, Math.min(100, (x / slideRect.width) * 100));
              const yPercent = Math.max(0, Math.min(100, (y / slideRect.height) * 100));
              img.style.transformOrigin = `${xPercent}% ${yPercent}%`;

              img.classList.toggle('is-zoomed');
              // 立即更新光标
              mainWrapper.style.cursor = img.classList.contains('is-zoomed') ? 'zoom-out' : 'zoom-in';
            }
          });


          // 2. 统一只在 mainWrapper 上设置 cursor，全局跟随鼠标平移
          mainWrapper.addEventListener('mousemove', (e) => {
            // 实时算出当前可视大图的 index
            let currentIndex = 0;
            let minDiff = Infinity;
            const scrollCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
            this.slides.forEach((slide, index) => {
              const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
              const diff = Math.abs(slideCenter - scrollCenter);
              if (diff < minDiff) {
                minDiff = diff;
                currentIndex = index;
              }
            });
            
            const activeSlide = this.slides[currentIndex];
            const img = activeSlide?.querySelector('img');
            
            if (img) {
              const isZoomed = img.classList.contains('is-zoomed');
              mainWrapper.style.cursor = isZoomed ? 'zoom-out' : 'zoom-in';
              
              // 无论大图是否已放大，只要鼠标在动，就默默在后台将其 transform-origin 与鼠标同步
              // 这样在点击切换放大的瞬间，大图早已完成了对准，绝不会产生任何瞬间跳动
              const slideRect = activeSlide.getBoundingClientRect();
              const x = e.clientX - slideRect.left;
              const y = e.clientY - slideRect.top;
              const xPercent = Math.max(0, Math.min(100, (x / slideRect.width) * 100));
              const yPercent = Math.max(0, Math.min(100, (y / slideRect.height) * 100));
              img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            }
          });

        } // if (mainWrapper)
      } // initGallery

      scrollBySlide(direction) {
        if (!this.slider || !this.slides.length) return;
        this.resetZoom();
        
        // 算出当前的 index
        let currentIndex = 0;
        let minDiff = Infinity;
        const scrollCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const diff = Math.abs(slideCenter - scrollCenter);
          if (diff < minDiff) {
            minDiff = diff;
            currentIndex = index;
          }
        });
        
        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = 0;
        if (nextIndex >= this.slides.length) nextIndex = this.slides.length - 1;
        
        this.goToSlide(nextIndex);
      }

      goToSlide(index) {
        if (!this.slider || !this.slides[index]) return;
        this.resetZoom();
        const targetLeft = this.slides[index].offsetLeft;
        this.slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
        
        // 立即高亮缩略图，实现0延迟跟手感
        this.highlightThumb(index);
      }

      updateActiveThumb() {
        if (!this.slider || !this.slides.length || !this.thumbs.length) return;
        const scrollCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
        let activeIndex = 0;
        let minDiff = Infinity;
        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const diff = Math.abs(slideCenter - scrollCenter);
          if (diff < minDiff) {
            minDiff = diff;
            activeIndex = index;
          }
        });
        this.highlightThumb(activeIndex);
      }

      resetZoom() {
        if (!this.slides) return;
        this.slides.forEach(slide => {
          const img = slide.querySelector('img');
          if (img) {
            img.classList.remove('is-zoomed');
            img.style.transformOrigin = '50% 50%';
          }
        });
      }

      highlightThumb(activeIndex) {
        if (!this.thumbs || !this.thumbs.length) return;
        this.thumbs.forEach((thumb, index) => {
          if (index === activeIndex) {
            thumb.classList.add('is-active');
            // 确保高亮的缩略图在可视范围内
            const thumbsContainer = this.querySelector('.custom-modal-thumbs');
            if (thumbsContainer) {
              const thumbRect = thumb.getBoundingClientRect();
              const containerRect = thumbsContainer.getBoundingClientRect();
              if (thumbRect.left < containerRect.left || thumbRect.right > containerRect.right) {
                 thumbsContainer.scrollTo({
                   left: thumb.offsetLeft - thumbsContainer.clientWidth / 2 + thumb.clientWidth / 2,
                   behavior: 'smooth'
                 });
              }
            }
          } else {
            thumb.classList.remove('is-active');
          }
        });
      }



      show(opener) {
        super.show(opener);
        // 定位到点击的图片
        if (this.openedBy) {
          const mediaId = this.openedBy.getAttribute('data-media-id');
          const activeSlideIndex = this.slides.findIndex(s => {
            const slideMediaId = s.getAttribute('data-media-id');
            return slideMediaId === mediaId || slideMediaId.endsWith(`-${mediaId}`);
          });
          if (activeSlideIndex !== -1) {
            // 初始化的时候用 auto 立刻过去，没有动画延迟
            const targetLeft = this.slides[activeSlideIndex].offsetLeft;
            this.slider.scrollTo({ left: targetLeft, behavior: 'auto' });
            setTimeout(() => {
              this.updateActiveThumb();
            }, 50);
          }
        }
      }

      hide() {
        super.hide();
      }
    }
  );
}
